import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlShipToAddressValidation = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlShipToAddressValidation);
};
